import React from 'react';

// Import all logos
import dukelogo from '../logos/Duke-University-Logo.jpg';
import usclogo from '../logos/usc_logo.png';
import gtechlogo from '../logos/gtech_logo.png';
import umichlogo from '../logos/umich_logo.png';
import ucsdlogo from '../logos/ucsd_logo.png';
import unclogo from '../logos/unc_logo.png';
import purduelogo from '../logos/purdue_logo.png';
import uiuclogo from '../logos/uiuc_logo.png';

const CollegeLogoCarousel: React.FC = () => {
  const logos = [
    { src: dukelogo, alt: 'Duke University' },
    { src: usclogo, alt: 'USC' },
    { src: gtechlogo, alt: 'Georgia Tech' },
    { src: umichlogo, alt: 'University of Michigan' },
    { src: ucsdlogo, alt: 'UC San Diego' },
    { src: unclogo, alt: 'UNC' },
    { src: purduelogo, alt: 'Purdue University' },
    { src: uiuclogo, alt: 'UIUC' },
  ];

  // Triple the logos to ensure smooth infinite scroll
  const extendedLogos = [...logos, ...logos, ...logos];

  return (
    <div className="border-t border-b border-gray-200 bg-gray-50">
      <div className="py-12">
        <div className="text-center mb-8 px-6">
          <h2 className="text-2xl lg:text-3xl font-semibold tracking-tight text-gray-900 mb-3">
            Trusted by Students Accepted To
          </h2>
          <p className="text-base text-gray-600">
            Our AI is trained on successful essays from top universities
          </p>
        </div>
        
        <div className="relative overflow-hidden bg-gradient-to-r from-gray-50 to-white py-8">
          <div 
            className="flex items-center"
            style={{
              animation: 'scroll 40s linear infinite',
              willChange: 'transform',
              width: 'fit-content'
            }}
          >
            {extendedLogos.map((logo, index) => (
              <div 
                key={index} 
                className="flex-none px-8 lg:px-12 flex items-center justify-center"
                style={{ width: '240px' }}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="max-h-12 lg:max-h-16 w-auto object-contain opacity-75 hover:opacity-100 transition-all duration-500 ease-in-out"
                />
              </div>
            ))}
          </div>
          
          {/* Gradient overlays for fade effect */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent pointer-events-none z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent pointer-events-none z-10" />
        </div>
      </div>

      <style>
        {`
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-66.67%);
            }
          }

          .flex {
            -webkit-font-smoothing: antialiased;
            backface-visibility: hidden;
            transform: translateZ(0);
          }
        `}
      </style>
    </div>
  );
};

export default CollegeLogoCarousel; 